import React, { useState, useEffect } from "react";
import { getReq } from "../middleware/AxiosApisCall";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../Loading";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination
} from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell} from '../Partials/TableStyle'

const PurchaseStockById = () => {
  const [loading, setLoading] = useState(false);
  const [stock, setStock] = useState({
    supplier: "",
    warehouse: "",
    products: [],
    invoiceNumber: "",
    date: "",
  });

  const purchaseStockListById = "purchaseStockListById?id=";
  const navigate = useNavigate();
  const { _id } = useParams();
  // const [itemid, setItemid] = useState(_id);

  // This Function is for getPurchasebyid
  const purchasedStockById = async () => {
    const response = await getReq(`${purchaseStockListById}${_id}`);
    setLoading(true);
    if (response?.data) {
      setStock(response.data[0]);
    } else {
      navigate(`../`);
    }
  };
  const dateObject = new Date(stock.date);
  const formattedDate = dateObject.toLocaleDateString();

  useEffect(() => {
    if (_id) {
      purchasedStockById();
    }
  }, [_id]);

  const { supplier, warehouse, invoiceNumber } = stock;

  return (
    <>
      {loading ? (
        <div className="add-user-container">
          <div className="headingdiv">
            <span className="componet-title"></span>
            <div>
              <button onClick={() => navigate(-1)}>Back</button>
            </div>
          </div>
          <div className="option-btn">
            <button
              onClick={() => {
                navigate("../purchasestocklist");
              }}
            >
              Purchase Stock List
            </button>
          </div>

          <>
            <div className="add-user-container">
              <form className="flex-col">
                <div className="input-lable-v-div">
                  <label>Supplier</label>
                  <input value={supplier} readOnly style={{cursor:'not-allowed'}} />
                </div>
                <div className="input-lable-v-div">
                  <label>Warehouse</label>
                  <input  value={warehouse} readOnly style={{cursor:'not-allowed'}} />
                </div>
                <div className="input-lable-v-div">
                  <label htmlFor="contactPerson">Invoice Number</label>
                  <input
                    type="text"
                    name="invoiceNumber"
                    value={invoiceNumber}
                    readOnly
                   style={{cursor:'not-allowed'}}
                  />
                </div>
                <div className="input-lable-v-div">
                  <label htmlFor="contactPerson">Date</label>
                  <input value={formattedDate} readOnly style={{cursor:'not-allowed'}}/>
                </div>
              </form>
            </div>

            {stock.products?.length > 0 ? (
              <div>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                       <StyledTableRow>
                         <HeaderTableCell>Sl no</HeaderTableCell>
                         <HeaderTableCell>Product</HeaderTableCell>
                         <HeaderTableCell>Qty</HeaderTableCell>
                         <HeaderTableCell>Price</HeaderTableCell>
                         <HeaderTableCell>Total Price</HeaderTableCell>
                       </StyledTableRow>
                     </TableHead>
                     <TableBody>
                        {stock.products.map((item, i) => (
                          <StyledTableRow key={item.product} sx={{
                            backgroundColor: i % 2 === 0 ? '#f5f5f5' : 'white',
                          }}>
                            <StyledTableCell align='center'>{i + 1}</StyledTableCell>
                            <StyledTableCell>{item.product}</StyledTableCell>
                            <StyledTableCell align='right'>{item.quantity}</StyledTableCell>
                            <StyledTableCell align='right'>{item.sellingPrice}</StyledTableCell>
                            <StyledTableCell align='right'>{item.totalPrice}</StyledTableCell>
                          </StyledTableRow>
                        ))}
                     </TableBody>
                  </Table>
                </TableContainer>
              </div>
            ) : (
              <Table>
                <TableHead>
                  <StyledTableCell>
                    <HeaderTableCell style={{ color: "white" }}>No data</HeaderTableCell>
                  </StyledTableCell>
                </TableHead>
              </Table>
            )}
          </>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default PurchaseStockById;
